import { useState, useEffect } from 'react';
import axios from 'axios';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { ImageSquare } from '@phosphor-icons/react';

const API = process.env.REACT_APP_BACKEND_URL;
export const IMG_TOKEN_RE = /\[\[img:([\w-]+)\]\]/g;
export const SUPPORT_SUBS = ['Porções', 'Montagem do prato', 'Cereais', 'Outros'];

export function EmbeddedImage({ id, className = '' }) {
  const [src, setSrc] = useState('');
  const [err, setErr] = useState(false);
  useEffect(() => {
    let url = '';
    axios.get(`${API}/api/embedded-image/${id}`, { responseType: 'blob', withCredentials: true })
      .then(r => { url = URL.createObjectURL(r.data); setSrc(url); }).catch(() => setErr(true));
    return () => { if (url) URL.revokeObjectURL(url); };
  }, [id]);
  if (err) return <span className="text-[10px] text-brand-muted">Imagem indisponível</span>;
  return src ? <img src={src} alt="Imagem de apoio" className={`max-w-full max-h-72 rounded-xl object-contain ${className}`} data-testid={`embedded-image-${id}`} /> : <span className="text-[10px] text-brand-muted">A carregar imagem...</span>;
}

export function RichNote({ text, className = '' }) {
  const parts = String(text || '').split(IMG_TOKEN_RE);
  return (
    <div className={className} data-testid="rich-note">
      {parts.map((p, i) => (i % 2 === 0 ? (p.trim() ? <p key={i} className="whitespace-pre-line">{p.trim()}</p> : null) : <div key={i} className="my-2"><EmbeddedImage id={p} /></div>))}
    </div>
  );
}

export function SupportImagePicker({ open, onClose, onPick }) {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState('');
  const [sub, setSub] = useState('');
  useEffect(() => {
    if (!open) return;
    axios.get(`${API}/api/support-images`, { params: { q, sub } }).then(r => setItems(r.data)).catch(() => setItems([]));
  }, [open, q, sub]);
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="rounded-3xl border-brand-border max-w-2xl" data-testid="support-image-picker">
        <DialogHeader><DialogTitle className="font-heading text-brand-text">Inserir imagem de apoio</DialogTitle></DialogHeader>
        <div className="flex gap-2 mb-2">
          <Input value={q} onChange={e => setQ(e.target.value)} placeholder="Pesquisar (alimento, quantidade, título)" className="rounded-xl border-brand-border" data-testid="support-image-search" />
          <select value={sub} onChange={e => setSub(e.target.value)} className="border border-brand-border rounded-xl px-2 text-sm bg-white" data-testid="support-image-sub">
            <option value="">Todas</option>{SUPPORT_SUBS.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 max-h-[55vh] overflow-y-auto">
          {items.map(it => (
            <button key={it.id} type="button" onClick={() => { onPick(it.id); onClose(); }} className="text-left border border-brand-border rounded-2xl p-2 hover:border-brand-green" data-testid={`support-image-${it.id}`}>
              <div className="h-24 flex items-center justify-center overflow-hidden rounded-xl bg-brand-bg"><EmbeddedThumb id={it.id} /></div>
              <p className="text-xs font-medium text-brand-text mt-1 truncate">{it.title}</p>
              <p className="text-[10px] text-brand-muted truncate">{[it.subcategory, it.food, it.quantity_range].filter(Boolean).join(' · ')}</p>
            </button>
          ))}
          {!items.length && <p className="col-span-full text-sm text-brand-muted" data-testid="support-image-empty">Sem imagens. Carrega-as em Materiais, na categoria "Imagens de apoio".</p>}
        </div>
      </DialogContent>
    </Dialog>
  );
}

function EmbeddedThumb({ id }) { return <EmbeddedImage id={id} className="max-h-24" />; }

export function InsertImageButton({ onPick, label = 'Inserir imagem', testId = 'insert-image-btn' }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className="text-xs text-brand-green flex items-center gap-1 border border-brand-green/30 rounded-full px-3 py-1" data-testid={testId}><ImageSquare size={13} /> {label}</button>
      <SupportImagePicker open={open} onClose={() => setOpen(false)} onPick={onPick} />
    </>
  );
}
